// extracted by mini-css-extract-plugin
export default {"title":"dHhow_W5","text":"RhV0Csjx","altButton":"KAUmT4L4"};